<!-- 
	@component
	Used in conjunction with `<Select>` to handle selection logic.

	Usage:
	```svelte
	<Select bind:selectedId>
		<div slot="input">{selectedId}</div>
		<SelectItem id="one">1</SelectItem>
		<SelectItem id="two">2</SelectItem>
		<SelectItem id="three">3</SelectItem>
	</Select>
	```
 -->
<script lang="ts">
	import { getContext } from 'svelte';
	import { GROUP_CONTEXT, type GroupContext } from '../Group/group';
	import { createEventDispatcher } from 'svelte';

	export let id: string;
	const context = getContext<GroupContext<string>>(GROUP_CONTEXT);
	const dispatch = createEventDispatcher();

	const { multiple } = context;
	let selected = false;
	context.register((values) => {
		selected = values.includes(id);
	});

	function onSelect() {
		context.select(id);
		dispatch('selected', id);
	}
</script>

<li
	on:click={onSelect}
	on:keypress={onSelect}
	class="cursor-pointer bg-base-200 first:pt-2 last:pb-2 hover:bg-base-300"
>
	{#if multiple}
		<label for="select-item" class="inline-flex items-center justify-center">
			<span class="pl-2">
				<input
					type="checkbox"
					checked={selected}
					class="checkbox-accent checkbox"
				/>
			</span>
			<slot />
		</label>
	{:else}
		<slot />
	{/if}
</li>
